import { ChangeEvent, useState } from "react";
import MyDiaryImg from "../../../assets/svgs/MyDiaryImg";
import parse from 'html-react-parser';
import './styles.css'
import { Button, Pagination, Typography } from "@mui/material";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { sxButton, sxSubtitle } from "./sxProps";
import { useNavigate } from "react-router-dom";
import { MyDiaryProps } from "../../../interfaces/props/SaudeBemEstar/MeuDiario/MyDiaryProps";
import HistoricItem from "./HistoricItem";
import { sxPagination, sxPaginationContrast } from "../../../assets/styles/CommonSxProps";
import VoltarButton from "../../../components/Accessibility/VoltarButton";


function MyDiary(props: MyDiaryProps) {
    const [page, setPage] = useState<number>(1);
    const accessibility = useAccessibility();
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/saudeBemEstar/unimedAcolhe/inicio');
    }

    const handleClick = () => {
        if (props.acceptDiary.indAceite === 'S') {
            navigate("/saudeBemEstar/unimedAcolhe/meuDiario/sintomas", { replace: true });
        }
        else {
            navigate("/saudeBemEstar/unimedAcolhe/meuDiario/historico", { replace: true });
        }
        props.handleStart()
    }

    const handlePageChange = (event: ChangeEvent<unknown>, newPage: number) => {
        setPage(newPage);
        // scrollTo('scroll-ref');
    };

    const paginatedHistoric = props.historic.slice(
        (page - 1) * 5,
        page * 5
    );

    return (
        <div className="my-diary-holder">
            <MyDiaryImg />
            <div className="my-diary-infos">
                {props.diary.details.length > 0 && parse(props.diary.details[0].diarioTexts[0].texto)}
            </div>
            <div className="start-registration-button">
                <Button
                    variant="contained"
                    size="large"
                    onClick={handleClick}
                    sx={sxButton}
                    style={{ ...accessibility.buttonStyleAccessibility, ...accessibility.buttonTextStyleAccessibility }}
                    fullWidth>
                    INICIAR REGISTRO
                </Button>
            </div>
            <Typography component="h2" sx={sxSubtitle}>Histórico</Typography>
            <ul style={{padding: '0', marginTop: '0'}}>
                {paginatedHistoric.map((item, index) => {
                    return (
                        <HistoricItem historicItem={item} />
                    )
                })}
            </ul>
            {props.historic.length > 5 &&
                <div className='pagination-holder'>
                    <Pagination
                        count={Math.ceil(props.historic.length / 5)}
                        sx={accessibility.contrastMode ? sxPaginationContrast : sxPagination} hideNextButton hidePrevButton
                        color='primary'
                        page={page}
                        onChange={handlePageChange}
                    />
                </div>
            }
            <VoltarButton onClick={handleBack} />
        </div>
    )
}

export default MyDiary;